import { ImagePickerOptions } from 'expo-image-picker';
import { SaveFormat } from 'expo-image-manipulator';

export const MEDIA_CONFIGS = {
  web: {} as ImagePickerOptions,
  native: {} as ImagePickerOptions,
  compression: {
    maxImageWidth: 1500,
    maxImageHeight: 1500,
    quality: 0.8,
    format: SaveFormat.JPEG,
  },
  maxVideoSizeMb: 50,
};
